const firebaseConfig = {
    apiKey: "AIzaSyDIfiP071zPnV4mrgoPWVWeX3YiLBmu1WQ",
    authDomain: "travel-guru-by-mahbub.firebaseapp.com",
    databaseURL: "https://travel-guru-by-mahbub.firebaseio.com",
    projectId: "travel-guru-by-mahbub",
    storageBucket: "travel-guru-by-mahbub.appspot.com",
    messagingSenderId: "194347667962",
    appId: "1:194347667962:web:d38d127797f9996ed95443"
  };

  export default firebaseConfig;